module.exports = __webpack_public_path__ + "static/img/honorMagic2.36901723.png";